export default __webpack_public_path__ + "static/media/LGSmHaTL.e5268f6a.woff2";